import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import './style.scoped.css';
import { Link } from 'react-router-dom';
import imageBackground from 'src/assets/online_insurrance_bg.svg';
import ProductOnline from 'src/models/ProductOnline';
import { ProductCode } from 'src/constants';
import { useHistory } from 'react-router-dom';
import homeStore, { HomeStore } from 'src/stores/HomeStore';
import { observer } from 'mobx-react-lite';

// import { sendOpenNewWebview } from 'src/utils';// Or "mobx-react".
interface HomeProductOnlineProps {
  title?: string;
  data?: ProductOnline[];
}

export const HomeProductOnline = (props: HomeProductOnlineProps) => {
  const { data, title } = props;
  const history = useHistory();

  const _handleClickItem = (item: ProductOnline) => {
    if (item.productCode == ProductCode.CANCER) {
      history.push('/buy-insurance/cancer/product-info');
    } else {
      history.push('/spa_insurrance_info');
    }
  };

  const _renderItem = (item: ProductOnline, index: number) => {
    return (
      <div
        key={item.id}
        className={`item ${
          item.productCode == ProductCode.CANCER
            ? 'bg-attention'
            : 'bg-secondary'
        } ${index < data.length - 1 ? 'mb-4' : ''}`}
        onClick={() => _handleClickItem(item)}
      >
        <div
          className={'itemImage'}
          key={item.id}
          style={{ backgroundImage: `url(${item.photoHome})` }}
        />
        <div className={'contentContainer'}>
          <img src={imageBackground} className="bgImage" />
          <div className="blockTitle name">{item.name}</div>
          <div className="flex items-center">
            <div className="description">{item.title}</div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <div className="mb-5 flex flex-row">
        <div className="blockTitle3 flex flex-1 text-onSurface">{title}</div>
      </div>
      {!!(data && data.length > 0) && (
        <div className="flex flex-col">{data.map(_renderItem)}</div>
      )}
    </div>
  );
};

interface HomeProductOnlineObserverProps {
  title?: string;
  store?: HomeStore;
}

const HomeProductOnlineObserver = observer(
  (props: HomeProductOnlineObserverProps) => {
    const { title, store } = props;
    return <HomeProductOnline data={store.homeOnlineProduct} title={title} />;
  }
);
export default HomeProductOnlineObserver;
